export function getCoreUrlPattern(year, submodel, subpage) {
  return `make/model/${year ? 'year/' : ''}${submodel ? 'submodel/' : ''}${subpage ? `${subpage}/` : ''}`;
}
